<template>
  <div>
    <!-- 标题 -->
    <div class=" titleText">
      <h3 v-if="title" style="margin-right: 20px;">{{ title }} </h3>
      <h3 v-if="title2">{{ title2 }}</h3>
    </div>
    <!-- TAB目录 -->
    <Row :gutter="8" style="margin: 0px 0 0 0; width: 100%" v-if="menus && menus.length > 0">
      <Menu mode="horizontal" :active-name="menu_name" @on-select="selectMenu" style="width: 100%">
        <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick" v-show="v.show === true ? false : true">
          <Badge :overflow-count="10000000" v-if="v.badge && v.badge.count" :count="v.badge.count" :offset="[18, -3]">
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>

    <Row :gutter="8" style="margin: 0px 0 0 0; width: 100%" v-if="filters && filters.length > 0">
      <Collapse style="width: 100%" v-model="value1">
        <!--  -->
        <Panel style="width: 100%" name="2">
          展开搜索条件
          <Form ref="formQuery" :label-width="75" :label-position="left" :label-colon="true" :model="query" style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            " slot="content">
            <Col span="3" :xxl="6" :xl="4" :lg="6" :md="8" :sm="12" :xs="24" style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              ">
            <Button icon="ios-search" type="info" @click="search" style="width: 90px">搜索
            </Button>
            <Button icon="ios-close-circle" type="error" @click="clearFilter"
              v-show="query.isClearFilterReset == true ? false : true" style="width: 90px; margin-right: 15px">重置
            </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24" v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <div style="margin-bottom: 0; display: flex">
                  <Input :key="k" :placeholder="'最小' + v.label" clearable v-model="query[v.name1]"></Input>
                  <div>~</div>
                  <Input :key="k" :placeholder="'最大' + v.label" clearable v-model="query[v.name2]"></Input>
                </div>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-if="v.type === 'string' || v.type === 'text' || v.type === 'input'"
                style="margin: 0px 0 10px 0; float: right; display: flex">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <Input :key="k" :placeholder="v.label" clearable v-model="query[v.name]"
                  @keyup.enter.native="v.KeyEnter"></Input>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24" v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <i-select :key="k" v-model="query[v.name]" clearable style="width: 190px"
                  @keyup.enter.native="v.KeyEnter" :multiple="v.multiple ? true : false"
                  :disabled="v.disabled ? true : false" :placeholder="v.label" :filterable="true"
                  @on-change="v.onChange">
                  <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk">{{ s.name }}
                  </Option>
                </i-select>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'selectsearch'" style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <i-select :key="k" v-model="query[v.name]" clearable remote filterable @keyup.enter.native="v.KeyEnter"
                  :remote-method="v.remoteMethod" style="width: 190px" :multiple="v.multiple ? true : false"
                  :disabled="v.disabled ? true : false" :placeholder="v.label" @on-change="v.onChange">
                  <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk">{{ s.name }}
                  </Option>
                </i-select>
              </FormItem>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'datetimerange'" style="margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <DatePicker clearable :key="k" type="daterange" v-model="query1[v.name + v.lable]" style="width: 190px"
                  @keyup.enter.native="v.KeyEnter" format="yyyy-MM-dd" placeholder="选择时间" :options="optionsData"
                  @on-change="
                    (val) => {
                      timeDateChange(val, v.name);
                    }
                  "></DatePicker>
              </FormItem>
              </Col>
              <Col :key="k" v-else-if="v.type === 'distpicker'" style="margin: 0px 0 10px 0; float: right">
              <FormAddress @on-change="
                (val) => {
                  onAddressChange(val, v.name);
                }
              " style="width: 100%"></FormAddress>
              </Col>
              <Col :key="k" span="3" :xxl="6" :xl="7" :lg="9" :md="12" :sm="12" :xs="24"
                v-else-if="v.type === 'addressInfo'" style="width: auto; margin: 0px 0 10px 0; float: right">
              <FormItem :label="v.label" style="margin-bottom: 0">
                <v-distpicker :disabeld="disabeld" type="addressInfo" :province="province" :city="city" :area="area"
                  @selected="v.onSelect"></v-distpicker>
              </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>

    <!-- 操作 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%" v-if="actions && actions.length > 0">
      <div v-for="(v, k) in actions" :key="k" style="margin-right: 10px; display: inline-flex">
        <Button :size="v.size || 'default'" :type="v.type || 'warning'" v-auth="v.auth" :icon="v.icon || ''"
          @click="v.onClick">{{ v.label }}
        </Button>
      </div>
    </Row>

    <!-- 表格 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <edit-table ref="tablelist" :query="query" :table="table" :order="table.order || ''"
        :rowClassName="table.rowClassName" :output="table.output" :border="table.border" :stripe="table.stripe"
        :header="table.header" :footer="table.footer" :columns-list="tableCols" :handleSpan="handleSpan"
        @on-select="handleSelect" @on-edit="handleEdit" @on-info="handleInfo" @on-del="handleDel">
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div v-for="(v, k) in tactions" :key="k" style="margin-right: 10px; display: inline-flex">
            <Button :size="v.size || 'default'" :type="v.type || 'primary'" v-auth="v.auth" :icon="v.icon || ''"
              :disabled="v.disabled" @click="v.onClick">{{ v.label }}
            </Button>
          </div>
        </div>
      </edit-table>
      <!-- <Badge   v-if="hospitaltype=='购物车'" :count="num" style="margin-top: 50px" > <Button @click="handleSubmit" style="background: #00c261;color: #f8f8f9;">提交申请</Button></Badge> -->
    </Row>
    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component v-for="(item, index) in extRender || []" :key="index" :ref="item" :is="item"></component>
  </div>
</template>
<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import Caigou from "./Procurementcomponents/caigou.vue";
import Caigouhetong from "./Procurementcomponents/caigouhetong.vue";
import Shenpi from "./Procurementcomponents/shenpi.vue";
import Fahuo from "./Procurementcomponents/fahuo.vue";
import Shouhuo from "./Procurementcomponents/shouhuo.vue";
import Changeprice from "./Changeprice.vue";
import config from "../../../config";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {
    baseList,
    Caigou,
    Shenpi,
    Fahuo,
    Shouhuo,
    Caigouhetong,
  },
  data() {
    return {
      authid: "",
      table: {
        mname: "procurementWork",
        key: "id",
        url: {
          list: "/admin/system/procurementWork/list",
        },
        output: false,
        order: "",
      },
      actions: [
        {
          label: "导出数据",
          type: "info",
          icon: "md-download",
          onClick: this.exportData,
        },
      ],
      filters: [
        {
          label: "医院名称",
          KeyEnter: this.search,
          name: "customerName",
          value: "",
          type: "input",
        },
        {
          label: "物资名称",
          KeyEnter: this.search,
          name: "consumableName",
          value: "",
          type: "input",
        },
        {
          label: "订单时间",
          KeyEnter: this.search,
          name: "receiveTime",
          value: "",
          type: "datetimerange",
        },
        /*{
          label: "派送人",
          name: "maintainerName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        }, */
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "订单编号",
          width: 180,
          align: "center",
          key: "procurementNum",
        },
        {
          title: "医院名称",
          width: 240,
          align: "left",
          key: "customerName",
        },
        {
          title: "物资信息",
          minWidth: 250,
          key: "sysProcurementDetails",
          render: (h, params) => {
            return (
              <div>
                {params.row.sysProcurementDetails.map((item) => {
                  const budget = item.jdPrice;
                  const num = new Intl.NumberFormat("zh-CN", {
                    style: "currency",
                    currency: "CNY",
                  }).format(budget);
                  return (
                    <div>
                      {item.brand ? item.brand + "/" : ""}
                      {item.model}/{item.name}*{item.alertNum}
                      {item.unit}-<span style="color:blue">单价: {num}</span>元
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "订单时间",
          width: 150,
          align: "center",
          key: "receiveTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveTime ? row.receiveTime.slice(0, 16) : null;
            return <span>{text}</span>;
          },
        },
        {
          title: "状态",
          width: 180,
          key: "state",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const state = row.state;
            const color =
              state === 1
                ? "orange"
                : state === 2
                  ? "green"
                  : state === 3
                    ? "green"
                    : state === 4
                      ? "green"
                      : state === 5
                        ? ""
                        : state === 6 || state === 7
                          ? " red"
                          : "";
            const text =
              state === 1
                ? row.receive + "已申请"
                : state === 2
                  ? row.examineBy + "已审核"
                  : state === 3
                    ? row.procurementBy + "采购中"
                    : state === 4
                      ? "正在派送中"
                      : state === 5
                        ? row.receive + "已收货"
                        : state === 6
                          ? row.examineBy + "拒绝审核"
                          : state === 7
                            ? "拒绝收货"
                            : "";
            return <span style={{ "font-size": "14px", color: color }}>{text}</span>;
          },
        },
        {
          title: "总价",
          width: 100,
          align: "center",
          key: "sendTotalPrice",
          /*  render: (h, params) => {
             const list = params.row.sysProcurementDetails;
             const totalPrice = this.calculateTotalPrice(list);
             const text = totalPrice.toFixed(2);
             return <span>{text}</span>;
           }, */
        },
        {
          title: "优惠后总价",
          width: 110,
          align: "center",
          /*  render: (h, params) => {
            const row = params.row.endTotalPrice ? params.row.endTotalPrice : 0;
            const text = row.toFixed(2);
            return <span>{text}</span>;
          }, */
          render: (h, params) => {
            const row = params.row.endTotalPrice ? params.row.endTotalPrice : 0;
            const text = row.toFixed(2);
            return (
              <Changeprice
                text={text}
                item={params.row}
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return currentRow.state === 1 && customerId == 0 ? (
                <Button
                  size="small"
                  onClick={() => this.handleShenpi(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  审核
                </Button>
              ) : null;
            },
            (vm, h, currentRow, param) => {
              return currentRow.state === 2 && customerId == 0 ? (
                <Button
                  size="small"
                  onClick={() => this.handleCaigou(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  采购
                </Button>
              ) : null;
            },
            (vm, h, currentRow, param) => {
              return currentRow.state === 3 && customerId == 0 ? (
                <Button
                  size="small"
                  onClick={() => this.handlefahuo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  发货
                </Button>
              ) : null;
            },
            (vm, h, currentRow, param) => {
              return currentRow.state >= 2 ? (
                <Button
                  size="small"
                  onClick={() => this.purchaseContract(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  新增合同
                </Button>
              ) : null;
            },
            (vm, h, currentRow, param) => {
              return currentRow.state >= 2 ? (
                <Button
                  size="small"
                  onClick={() => this.getprocureInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    margin: "5px 0 5px 5px",
                  }}
                >
                  查看合同
                </Button>
              ) : null;
            },
          ],
        },
      ],
    };
  },
  created() {
    this.authid = $utils.data.get("auth", "uid");
    let query = this.$route.query;
    if (query.inventoryId) {
      this.query.inventoryId = query.inventoryId;
    }
    if (query.customerName || query.receiveTime || query.begin || query.end) {
      this.query.customerName = query.customerName;
      this.query.receiveTime = query.receiveTime;
      let arr = [query.begin, query.end];
      this.timeDateChange(arr);
    }
    this.initDatas();
  },
  methods: {
    async exportData() {
      let q = {};
      q.query = this.query;
      let qq = this.query || {};
      for (const key in qq) {
        if (Object.hasOwnProperty.call(qq, key)) {
          const element = qq[key];
          if (element) {
            q[key] = element;
          }
        }
      }
      this.$Message.info("数据正在导出，请稍后");
      $utils.api
        .load(`/admin/system/procurementWork/export`, q, "GET")
        .then((res) => {
          if (res) {
            this.urldata = res.msg;
            window.location.href =
              config.API_HOST + `/admin/common/download?fileName=${this.urldata}`;
          }
        })
        .catch((err) => {
          $utils.loading.hide();
        });
    },
    calculateTotalPrice(products) {
      return products.reduce((total, product) => {
        return total + product.jdPrice * product.alertNum;
      }, 0);
    },
    getprocureInfo(row) {
      $utils.url.push({
        name: "PurchaseOrder",
        query: { procurementNum: row.procurementNum },
      });
    },
    initDatas() {
      // 加载详情数据
      $utils.api
        .load(`/admin/system/procurementWork/sumMoney`, this.query, "get")
        .then((res) => {
          if (res.code == 200) {
            let data = res.data;
            this.title = "总价:" + (data.sendTotalPriceSum ? data.sendTotalPriceSum : 0) + "元";
            this.title2 = "优惠后总价:" + (data.endTotalPriceSum ? data.endTotalPriceSum : 0) + "元";
          }
        });
    },
    handleEdit(row) {
      $utils.url.push({
        name: "ProcureInfo",
        query: { kv: row.id },
      });
    },
    //单个采购
    handleCaigou(row) {
      this.$Modal.success({
        closable: true,
        title: "采购订单",
        width: "1100px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <Caigou item={row.id} onClose={() => this.onClose()}></Caigou>;
        },
      });
    },
    //新增采购合同
    purchaseContract(row) {
      this.$Modal.success({
        closable: true,
        title: "新增采购合同",
        width: "800px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Caigouhetong
              item={row.id}
              action="add"
              onClose={() => this.onClose()}
            ></Caigouhetong>
          );
        },
      });
    },
    //审核
    handleShenpi(row) {
      this.$Modal.success({
        closable: true,
        title: "审核",
        width: "1100px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <Shenpi item={row.id} onClose={() => this.onClose()}></Shenpi>;
        },
      });
    },
    //发货
    handlefahuo(row) {
      this.$Modal.success({
        closable: true,
        title: "发货",
        width: "1100px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <Fahuo item={row.id} onClose={() => this.onClose()}></Fahuo>;
        },
      });
    },
  },
};
</script>
<style scoped>
.titleText {
  display: flex;
}
</style>
